module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAMAAADNlS1EAAAAUVBMVEVRUVFQUFBRUVFSUlJQUFBRUVFQUFBMaXFPT09RUVFQUFBQUFBOTk5QUFBRUVFPT09QUFBQUFBQUFBQUFBQUFBPT09SUlJRUVFSUlJQUFBRUVF4u9kYAAAAGnRSTlNwv1cM0IAwAGCQ8egClqYg02jkod1DPs9HheIIO/YAAACESURBVHjabc1HDsMwDERRqpmOinva3P+ggYUIIET9zYBvQ+K7gH+hng3nWodca+jvEnwNqQ7BPLoMCMStzDWS+Jo0Zj/AHRpdHGCBxgkbSghPidkcNkbEVaKFZf6AWKA7cJ7uemeJ1pgLX0z9dwIKa0xugJY1Gta4rwN0LHGZuxYQBv0A7rYTRHCtn3AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/icon-battery.png
// module id = 3FrR
// module chunks = 0